<template>
    <div class="map-house-menu">
        <house-mgt-mode-switch></house-mgt-mode-switch>
        <div class="total">
            共 {{filterByHouseId.length}} 房源
        </div>
        <tabs>
            <tab name="全部" :selected="true">
                <map-house-card  v-for="(houseItem,index) in filterByHouseId" :key="index" :house="houseItem" ></map-house-card>
                <div class="no-house" v-if="houseMgtList.length == 0 && !HmgtIsLoading">
                    <img src="@/assets/img/state/hmgt_no_house.svg" alt="">
                    0 筆資料，尚未新增任何房源
                </div>
            </tab>
            <tab name="已租">
                <map-house-card  v-for="(houseItem,index) in filterRented" :key="index" :house="houseItem" ></map-house-card>
            </tab>
            <tab name="未租">
                <map-house-card  v-for="(houseItem,index) in filterUnRented" :key="index" :house="houseItem" ></map-house-card>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import MapHouseCard from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/mapMode//MapHouseCard.vue';
import houseMgtModeSwitch from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/houseMgtModeSwitch.vue';
import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            filterEmpty: false,
            houseMgtDataEmpty: false,
            houseMgtDataError: false,
            isLoading: true,
        }
    },
    mounted() {
        // console.log(this.$el.querySelector(".tabs-details"))
        this.$el.querySelector(".tabs-details").style.height = (window.innerHeight-213)+'px'
    },
    methods: {
    },
    computed:{
        filterByWord: function () {
            return this.houseMgtList.filter((houseItem) => {
                if( this.filterWord ){
                    if( houseItem.houseName.includes(this.filterWord) || houseItem.address.includes(this.filterWord) ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByCounty: function () {
            return this.filterByWord.filter((houseItem) => {
                if(this.filterQuery.county){
                    if(houseItem.county === this.filterQuery.county){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((houseItem) => {
                if( this.filterQuery.district){
                    if(houseItem.district === this.filterQuery.district){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByRent: function () {
            return this.filterByDistrict.filter((houseItem) => {
                // if( this.filterQuery.rent ){
                //     if( this.filterQuery.rent[0] <= houseItem.rentPrice && this.filterQuery.rent[1] >= houseItem.rentPrice ){
                //         return houseItem
                //     }
                // }else{
                //     return houseItem
                // }
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[1] >= 100000){
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice){
                            return houseItem
                        }
                    }else{
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice && this.filterQuery.rent[1] >= houseItem.rentPrice ){
                            return houseItem
                        }
                    }
                    
                }else{
                    return houseItem
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByRent.filter((houseItem) => {
                if( this.filterQuery.houseType ){
                    if( this.filterQuery.houseType == houseItem.houseType ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByBuildingType: function () {
            return this.filterByHouseType.filter((houseItem) => {
                if( this.filterQuery.buildingType ){
                    if( this.filterQuery.buildingType == houseItem.buildingType ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByTask: function () {
            return this.filterByBuildingType.filter((houseItem) => {
                if( this.filterQuery.task ){
                    if( this.filterQuery.task == 0 ){
                        if( houseItem.taskStatus == 0 ){
                            return houseItem
                        }
                    }else if( this.filterQuery.task == 1 ){
                        if( houseItem.taskStatus == 1 ){
                            return houseItem
                        }
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByHouseId: function () {
            return this.filterByTask.filter((houseItem) => {
                if( this.clusterHouseId.length > 0 ){
                    if( this.clusterHouseId.includes(houseItem.cid) ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterRented: function () {
            return this.filterByHouseId.filter((houseItem) => {
                if(houseItem.empty == 0){
                    return houseItem
                }
            });
        },
        filterUnRented: function () {
            return this.filterByHouseId.filter((houseItem) => {
                if(houseItem.empty == 1){
                    return houseItem
                }
            });
        },
        ...mapGetters({
            houseMgtList: 'GET_BIZ_HOUSE_MGT_LIST',
            filterQuery: 'GET_BIZ_HOUSE_MGT_FILTER_QUERY',
            filterWord: 'GET_BIZ_HOUSE_MGT_FILTER_WORD',
            clusterHouseId: 'GET_BIZ_HOUSE_MGT_CLUSTER_HOUSE_ID',
            HmgtIsLoading: 'GET_BIZ_HOUSE_MGT_LOADING',
        }),
    },
    components: {
        Tabs,
        Tab,
        houseMgtModeSwitch,
        MapHouseCard
    }
}
</script>
<style lang="scss">
    .map-house-menu{
        position: fixed;
        .view-model{
            margin-left: 24px;
        }
        .total{
            font-size: 20px;
            color: #a8a5a4;
            padding: 0 24px;
            margin-top: 30px;
            margin-bottom: 30px;
        }
        .no-house{
            width: 100%;
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img{
                width: 200px;
                margin-bottom: 30px;
            }
        }
        .tabs{
            padding: 0 24px;
            margin-bottom: 32px;
        }
        .tabs-details{
            overflow-x: hidden;
            height: 500px;
            >div{
                margin-bottom: 200px;
            }
        }
        .tabs-details::-webkit-scrollbar {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/houseMgt/mapMode/MapHouseMenu.vue